import { render, staticRenderFns } from "./ArticleTeliaProjectScroller.vue?vue&type=template&id=3a9e5eba"
import script from "./ArticleTeliaProjectScroller.vue?vue&type=script&lang=ts"
export * from "./ArticleTeliaProjectScroller.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTeliaProjectScroller.vue?vue&type=style&index=0&id=3a9e5eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports